import _ from 'underscore';
import { updateCreativeGroupSync } from './actions';

export default function CreativeGroupService($ngRedux, CreativeService) {
  const vm = this;
  vm.setCreativeGroup = setCreativeGroup;
  vm.addCreativeToList = addCreativeToList;
  vm.reset = reset;
  vm.removeFromList = removeFromList;

  reset();
  function updateStore(groupData) {
    $ngRedux.dispatch(updateCreativeGroupSync(groupData));
  }

  function setCreativeGroup(group) {
    vm.group = group;

    updateStore(vm.group);
    CreativeService.setCreative(group.creativePreviews[0]);
  }

  function reset() {
    vm.group = {
      name: null,
      creativePreviews: [CreativeService.creative]
    };
    updateStore(vm.group);
  }

  function addCreativeToList(creative) {
    vm.group.creativePreviews.push(creative);
    const index = vm.group.creativePreviews.length - 1
    CreativeService.setCreative(vm.group.creativePreviews[index])
  }

  function removeFromList(creative) {
    vm.group.creativePreviews = _.without(vm.group.creativePreviews, creative);
  }

  return vm;
}

CreativeGroupService.$inject = ['$ngRedux', 'CreativeService'];
